import { render, staticRenderFns } from "./ThirdTag.vue?vue&type=template&id=16508b68&scoped=true&"
import script from "./ThirdTag.vue?vue&type=script&lang=js&"
export * from "./ThirdTag.vue?vue&type=script&lang=js&"
import style0 from "./ThirdTag.vue?vue&type=style&index=0&id=16508b68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16508b68",
  null
  
)

export default component.exports